import React from 'react';

import {
	getRecentSearches,
	RECENT_SEARCH_KEY,
	getRecentQueryObject,
} from '@atlassian/search-common/recent-searches';

import { type PrimaryProductKey } from '../../../common/constants/products';
import { type SearchLinkProps } from '../../../common/ui/search-link/types';
import { filterSearchResultsWithHighlighting } from '../../../common/utils/filter-search-results';

export const prefetchRecentSearchResults: (
	primaryProduct?: PrimaryProductKey,
	userId?: string | null,
) => {
	title: string;
	icon: React.JSX.Element;
	onClick: () => null;
}[] = (
	primaryProduct?: PrimaryProductKey,
	userId?: string | null,
): {
	title: string;
	icon: React.JSX.Element;
	onClick: () => null;
}[] => {
	if (userId && primaryProduct) {
		return getRecentSearches({
			userId,
			productId: primaryProduct,
			key: RECENT_SEARCH_KEY,
		}).map((recentSearch) => {
			const { query } = getRecentQueryObject(recentSearch);
			return {
				title: query,
				icon: <></>,
				onClick: () => null,
			};
		});
	}
	return [];
};

export const filterRecentSearchResults: (
	recentSearches: SearchLinkProps[],
	inputQuery: string,
) => SearchLinkProps[] = (recentSearches: SearchLinkProps[], inputQuery: string) => {
	if (inputQuery.length === 0) {
		return recentSearches;
	}
	return filterSearchResultsWithHighlighting(
		recentSearches,
		inputQuery,
		inputQuery.length < 3 ? 3 : 2,
		true,
	);
};
